export default "__VITE_ASSET__f8333487__"